<div class="container">
  <div class="logo">
    <img width="250px" src="../../../../../assets/logo_red.svg" alt="E11even logo" />
  </div>
  <div *ngIf="!existingMemberCheck; else existing">
    <h2 class="title">Hi, welcome to Hayrick!</h2>
    <br />
    <h4 class="intro">Business number 1 has invited you to join their business account</h4>
    <br />
    <h4 class="intro">Get started by entering your details below</h4>
    <h1 class="title">Sign up</h1>

    <div class="input-box">
      <form [formGroup]="signupForm">
        <div class="input-container">
          <input required maxlength="15" formControlName="firstname" id="firstname" placeHolder="First name" class="firstname" type="" />

          <input required maxlength="15" formControlName="lastname" id="lastname" placeHolder="Last name" class="lastname" type="" />

          <div class="email-container">
            <div class="dropdown">
              <select class="select" name="country">
                <option class="option" value="au">South Africa</option>
                <option class="option" value="ca">Botswana</option>
                <option class="option" value="usa">Mozambique</option>
              </select>
            </div>

            <input formControlName="email" id="email" placeHolder="Work email address" class="lastname" type="" />
          </div>

          <input required maxlength="10" formControlName="mobile" id="mobile" placeHolder="Phone number" class="phone-number" type="" />

          <div *ngIf="mobile.invalid" class="ng-invalid">
            <p class="valid-number-text">Please enter a valid phone number</p>
          </div>
        </div>
      </form>
    </div>
    <div class="signinbutton">
      <button [disabled]="signupForm.invalid" (click)="goToPasscode()" class="sign-in-button">SIGN UP</button>

      <div class="exisitng-member">
        <p (click)="existingMember()" class="valid-number-text">Already a user? signin</p>
      </div>
    </div>
  </div>
</div>

<ng-template #existing>
  <div>
    <h2 class="title">Hi, welcome back to Hayrick!</h2>
    <h1 class="title">Sign In!</h1>

    <div class="input-box">
      <form [formGroup]="signinForm">
        <div class="input-container">
          <input required maxlength="4" formControlName="passcode" id="passcode" placeHolder="passcode" class="lastname" type="" />

          <input
            required
            maxlength="10"
            formControlName="mobileSignin"
            id="mobileSignin"
            placeHolder="Phone number"
            class="phone-number"
            type=""
          />

          <div *ngIf="mobileSignin.invalid" class="ng-invalid">
            <p class="valid-number-text">Please enter a valid phone number</p>
          </div>
        </div>
      </form>
    </div>

    <div class="signinbutton">
      <button [disabled]="signinForm.invalid" (click)="signIn()" class="sign-in-button">Sign In!</button>
      <div class="exisitng-member">
        <p (click)="newMember()" class="valid-number-text">New user? Sign up</p>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="isSignUpLoading$ | async as isLoading">
  <div *ngIf="isLoading"></div>
</div>

<div *ngIf="signupFailure$ | async as fail">
  {{ fail.Message }}
  <div *ngIf="fail !== null">
    <app-error-modal [errorMessage]="fail.Message"></app-error-modal>
  </div>
</div>
